import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { CustomPicker } from './components/CustomPicker';

const customPickerFormField = FormFieldBlueprint.make({
  name: 'custom-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'CustomPicker',
        component: CustomPicker,
      }),
  },
});

export const customPickerScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [customPickerFormField],
});
